import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SeoService } from './seo.service';

/**
 * Gates the SEO screens. If the add-on isn't enabled for the company, or the
 * customer hasn't finished onboarding, send them to the onboarding screen
 * (which shows the right message and the setup wizard). The onboarding route
 * itself is NOT guarded, so it's always reachable.
 */
export const seoAccessGuard: CanActivateFn = () => {
    const seo = inject(SeoService);
    const router = inject(Router);
    return seo.status().pipe(
        map((s) => {
            if (s?.enabled && s?.onboarded) return true;
            return router.createUrlTree(['/seo/onboarding']);
        }),
        catchError(() => of(router.createUrlTree(['/seo/onboarding'])))
    );
};
